import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import { ManagePaths } from '../constants/routes';
export const getAiSettingsUrl = () => `${getFullUrl('app')}/ai-settings/${PortalIdParser.get()}`;

// Breeze Studio (AI Studio) path prefix — used by in-app routes below and across the app.
export const getBaseUrl = () => '/breeze-studio';
export const getRootUrl = () => `${getBaseUrl()}/${PortalIdParser.get()}`;

// Shared `agentInstanceId` / `executionId` query for both inbox surfaces.

const getInboxSearch = ({
  agentInstanceId,
  executionId,
  filterAgentInstanceIds
}) => {
  const searchParams = new URLSearchParams();
  // Selection param: drives which execution/agent is auto-selected on load.
  searchParams.set('agentInstanceId', String(agentInstanceId));
  if (executionId !== null && executionId !== void 0 && executionId.trim()) {
    searchParams.set('executionId', executionId);
  }
  if (filterAgentInstanceIds && filterAgentInstanceIds.length > 0) {
    searchParams.set('filterAgentInstanceIds', filterAgentInstanceIds.map(String).join(','));
  }
  const searchString = searchParams.toString();
  return searchString ? `?${searchString}` : '';
};

// Inbox inside Breeze Studio (`…/manage-agents/inbox`)
export const getInboxLandingUrl = () => `${getFullUrl('app')}${getRootUrl()}${ManagePaths.INBOX}`;
export const getInboxRoute = params => `${ManagePaths.INBOX}${getInboxSearch(params)}`;
export const getInboxUrl = params => `${getFullUrl('app')}${getRootUrl()}${getInboxRoute(params)}`;

// AgentInbox app (`/agent-inbox/...`)
export const getAgentInboxBaseUrl = () => '/agent-inbox';
export const getAgentInboxRootUrl = () => `${getAgentInboxBaseUrl()}/${PortalIdParser.get()}`;
export const getAgentInboxUrl = () => `${getFullUrl('app')}${getAgentInboxRootUrl()}`;
export const getAgentInboxSelectionUrl = params => `${getFullUrl('app')}${getAgentInboxRootUrl()}${getInboxSearch(params)}`;
export const getSettingsUrl = () => `/settings/${PortalIdParser.get()}/account-defaults/general`;
export const getCreditsSettingsUrl = () => `/account-and-billing/${PortalIdParser.get()}/usage/hubspot-credits`;
export const redirectToMainSettings = () => {
  window.location.href = `${getFullUrl('app')}${getSettingsUrl()}`;
};
export const getMarketplaceUrl = () => `${getFullUrl('app')}/marketplace/${PortalIdParser.get()}`;
export const getAgentMarketplaceUrl = referrer => {
  const searchParams = new URLSearchParams();
  searchParams.set('eco_PRODUCT_TYPE', 'AGENT');
  searchParams.set('eco_AGENT_TYPE', 'STUDIO');
  if (referrer) {
    searchParams.set('referrer', referrer);
  }
  return `${getMarketplaceUrl()}/explore?${searchParams.toString()}`;
};
export const getAssistantMarketplaceUrl = referrer => {
  const searchParams = new URLSearchParams();
  searchParams.set('eco_PRODUCT_TYPE', 'AGENT');
  searchParams.set('eco_AGENT_TYPE', 'ASSISTANT');
  if (referrer) {
    searchParams.set('referrer', referrer);
  }
  return `${getMarketplaceUrl()}/explore?${searchParams.toString()}`;
};
export const getMarketplaceListingUrl = (listingSlug, referrer = 'breeze') => {
  const searchParams = new URLSearchParams();
  searchParams.set('referrer', referrer);
  return `${getMarketplaceUrl()}/listing/${listingSlug}?${searchParams.toString()}`;
};
export const getConnectedAppsUrl = () => `${getFullUrl('app')}/connected-apps/${PortalIdParser.get()}/installed`;
export const getUserUrl = userId => `${getFullUrl('app')}/settings/${PortalIdParser.get()}/users/user/${userId}`;
const getWorkflowsBaseUrl = () => `${getFullUrl('app')}/workflows/${PortalIdParser.get()}`;
export const getCreateWorkflowUrl = ({
  agentInstanceId
}) => {
  const createUrl = `${getWorkflowsBaseUrl()}/create`;
  if (agentInstanceId) {
    const searchParams = new URLSearchParams();
    searchParams.set('agentInstanceId', String(agentInstanceId));
    return `${createUrl}?${searchParams.toString()}`;
  }
  return createUrl;
};
export const getEditWorkflowUrl = ({
  workflowId
}) => {
  return `${getWorkflowsBaseUrl()}/platform/flow/${workflowId}/edit`;
};
const getAutomationBaseUrl = () => `${getFullUrl('app')}/automation/${PortalIdParser.get()}`;
export const getAutomationFlowUrl = ({
  workflowId,
  referrer
}) => {
  const base = `${getAutomationBaseUrl()}/flow/${workflowId}`;
  if (referrer) {
    const searchParams = new URLSearchParams();
    searchParams.set('referrer', referrer);
    return `${base}?${searchParams.toString()}`;
  }
  return base;
};
export const getModernEditorAgentUrl = ({
  agentInstanceId,
  referrer
}) => {
  const base = `${getAutomationBaseUrl()}/agent/${agentInstanceId}`;
  if (referrer) {
    const searchParams = new URLSearchParams();
    searchParams.set('referrer', referrer);
    return `${base}?${searchParams.toString()}`;
  }
  return base;
};